import { Link } from "react-router-dom"; // or use `Link` from 'react-router-dom'
import { FaFacebook, FaInstagram, FaYoutube } from "react-icons/fa";
import food3 from "../Assets/food3.webp";
import TheBeautyPEACE from "../Assets/TheBeautyPEACE.webp";
import escape from "../Assets/escape.webp";


const OptionCards = () => {
  return (
    <>
    
    <section className="bg-green-950 py-12 px-4 md:px-8 lg:px-20">
        {/* Card Row */}
        <div className="flex flex-row justify-center gap-6 flex-wrap">
          {/* Card 1 */}

          <div className="bg-white flex flex-col w-80 rounded overflow-hidden shadow-md">
            {/* Image Container with overflow-hidden */}
            <div className="w-full h-64 overflow-hidden">
              <img
                src={escape} 
                loading="lazy"
                alt="ESCAPE PLAN"
                className="w-full h-full object-cover transform transition-transform duration-500 hover:scale-105"
              />
            </div>

            {/* Text Content */}
            <div className="px-4 py-10 text-center flex-1 flex flex-col justify-between">
              <h3 className="text-lg font-semibold text-gray-900">
                ESCAPE PLAN
              </h3>
              <p className="text-sm text-gray-700 mt-1 mb-2">
                Discover blissful retreats with our meticulously crafted
                one-night and two-night escape plans.
              </p>

              <Link to="/escape-plan">
                <button className="text-gray-800 mt-2 px-4 py-2 border border-black rounded hover:bg-gray-100 transition w-fit mx-auto">
                  View more
                </button>
              </Link>
            </div>
          </div>
          <div className="bg-white flex flex-col w-80 rounded overflow-hidden shadow-md">
            {/* Image Container with overflow-hidden */}
            <div className="w-full h-64 overflow-hidden">
              <img
                src={food3}
                loading="lazy"
                alt="food"
                className="w-full h-full object-cover transform transition-transform duration-500 hover:scale-105"
              />
            </div>

            {/* Text Content */}
            <div className="px-4 py-10 text-center flex-1 flex flex-col justify-between">
              <h3 className="text-lg font-semibold text-gray-900">
                CAFE D' CONFLUENCE
              </h3>
              <p className="text-sm text-gray-700 mt-1 mb-2">
                Embark on a culinary adventure at Cafe d Confluence, our
                restaurant open to guests of all plans
              </p>

              <Link to="/cafe-d-confluence">
                <button className="text-gray-800 mt-2 px-4 py-2 border border-black rounded hover:bg-gray-100 transition w-fit mx-auto">
                  View more
                </button>
              </Link>
            </div>
          </div>
          <div className="bg-white flex flex-col w-80 rounded overflow-hidden shadow-md">
            {/* Image Container with overflow-hidden */}
            <div className="w-full h-64 overflow-hidden">
              <img
                src={TheBeautyPEACE}
                alt="GALLERY" loading="lazy"
                className="w-full h-full object-cover transform transition-transform duration-500 hover:scale-105"
              />
            </div>

            {/* Text Content */}
            <div className="px-4 py-10 text-center flex-1 flex flex-col justify-between">
              <h3 className="text-lg font-semibold text-gray-900">GALLERY</h3>
              <p className="text-sm text-gray-700 mt-1 mb-2">
                Featuring a wide array of images, an immersive experience that
                transcends the ordinary
              </p>

              <Link to="/gallery">
                <button className="text-gray-800 mt-2 px-4 py-2 border border-black rounded hover:bg-gray-100 transition w-fit mx-auto">
                  View more
                </button>
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-12 flex flex-col md:flex-row justify-evenly items-center ">
          <h2 className="text-white text-3xl ">Visit For More Updates</h2>
          <div className="flex gap-2">
            <a
              href="https://www.facebook.com/skbmunroeisland?mibextid=LQQJ4d"
              aria-label="fb"
            >
              <div className="bg-blue-600 p-2 rounded flex items-center justify-center">
                <FaFacebook className="text-white text-3xl" />
              </div>
            </a>
            <a
              href="https://www.instagram.com/lakenriver.resort.munroeisland/"
              aria-label="Instagram"
            >
              <div className="bg-red-500 p-2 rounded flex items-center justify-center">
                <FaInstagram className="text-white text-3xl" />
              </div>
            </a>
            <a
              href="https://www.youtube.com/@lakenriverresortmunroeisla8334"
              aria-label="YouTube"
            >
              <div className="bg-red-600 p-2 rounded flex items-center justify-center">
                <FaYoutube className="text-white text-3xl" />
              </div>
            </a>
          </div>
        </div>

        {/* Green HR Line */}
        <hr className="mt-8 border-green-700" />
      </section>

    </>
  )
}

export default OptionCards